const ITEMS = [
  "GÜTERTRANSPORT KARLSRUHE",
  "EXPRESS-PAKETE & PALETTEN",
  "REIFEN & AUTOZUBEHÖR",
  "RADWECHSEL & WUCHTEN",
  "DECARBONISIERUNG",
  "11. TRANSPORT KOSTENLOS",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative border-y border-white/5 bg-[#0d1320] py-5 overflow-hidden" aria-hidden="true">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="text-sm font-semibold tracking-[0.3em] text-slate-500 px-8" style={{ fontFamily: "'Outfit', sans-serif" }}>
                  {item}
                </span>
                <span className="w-1.5 h-1.5 rounded-full bg-cyan-400/60" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
